import { render, staticRenderFns } from "./VBalanceList.vue?vue&type=template&id=fcd5dd98&scoped=true"
import script from "./VBalanceList.vue?vue&type=script&lang=ts"
export * from "./VBalanceList.vue?vue&type=script&lang=ts"
import style0 from "./VBalanceList.vue?vue&type=style&index=0&id=fcd5dd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd5dd98",
  null
  
)

export default component.exports